<template>
  <div ref="cell" class="grid-view__cell grid-field-many-to-many__cell active">
    <div
      ref="dropdownLink"
      class="grid-field-many-to-many__list grid-field-multiple-select__list"
    >
      <div
        v-for="item in value"
        :key="item.id"
        class="grid-field-multiple-select__item"
        :class="'background-color--' + item.color"
      >
        <div class="grid-field-many-to-many__name">
          <SearchHighlightedText :text="item.value" :search-term="searchTerm" />
        </div>
        <!--
          `button` rather than an `<a>` without an `href`, which is neither
          focusable nor exposed with a role, so these could not be operated by
          keyboard.
        -->
        <button
          v-if="!readOnly"
          type="button"
          class="grid-field-many-to-many__remove"
          :aria-label="
            $t('gridViewFieldMultipleSelect.removeOption', {
              value: item.value,
            })
          "
          @click.prevent="removeValue($event, value, item.id)"
        >
          <i class="iconoir-cancel"></i>
        </button>
      </div>
      <button
        v-if="!readOnly"
        type="button"
        class="grid-field-many-to-many__item grid-field-many-to-many__item--link"
        :aria-label="$t('gridViewFieldMultipleSelect.addOption')"
        @click.prevent="toggleDropdown()"
      >
        <i class="iconoir-plus"></i>
      </button>
    </div>
    <FieldSelectOptionsDropdown
      v-if="!readOnly"
      ref="dropdown"
      :options="availableSelectOptions"
      :show-input="false"
      :show-empty-value="false"
      :allow-create-option="true"
      class="dropdown--floating"
      @show="editing = true"
      @hide="editing = false"
      @input="updateValue($event, value)"
      @create-option="createOption($event)"
    ></FieldSelectOptionsDropdown>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import multipleSelectField from '@baserow/modules/database/mixins/multipleSelectField'
import FieldSelectOptionsDropdown from '@baserow/modules/database/components/field/FieldSelectOptionsDropdown'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { FieldSelectOptionsDropdown, SearchHighlightedText },
  mixins: [gridField, multipleSelectField],
  emits: ['editing-changed'],
  data() {
    return {
      editing: false,
    }
  },
  watch: {
    editing(editing) {
      this.$emit('editing-changed', editing)
    },
  },
}
</script>
